<template>
    <div class="include"> 
        <p class="tit">经典名方</p>
        <el-table 
            class="table-list"
            width='100%' 
            v-loading='tableLoad'
            :data="tableList"
            :header-cell-style="{background:'#396de7',color:'#fff' }"
            :row-class-name="tableRowClassName"
        >
            
            <el-table-column align='center' label='方剂名称'  prop="title" width='240'> </el-table-column>
            <el-table-column align='center' label='方剂组成'  prop="cywzc">
                <template slot-scope="scope">
                   <p v-html="scope.row.cywzc"></p>             
                </template> 
            </el-table-column> 
            <el-table-column align='center' label='来源'  prop="cc" width='180'> </el-table-column>
            <el-table-column align='center' label='相似度'  prop="alike"  width='140'> </el-table-column>  
            <el-table-column
                align='center'
                label="操作" 
                width='100'
            >
                <template slot-scope="scope"> 
                    <el-button class="table-column-btn" type="text"  @click="toDetails(scope.row)">查看详情</el-button>   
                </template>
            </el-table-column>
        </el-table>
        <fjDetails v-if='isDetails'  :show.sync='isDetails' :rowInfo='rowInfo'></fjDetails>
        <el-pagination  
            class="page-wrap"  
            @current-change="changePage" 
            @size-change="sizeChange"
            background
            :current-page="pageInfo.pageNum" 
            :page-count="pageInfo.pageTotal" 
            :page-size="pageInfo.pageSize"
            :page-sizes="[10, 20, 30, 50, 100]"
            :total="pageInfo.total"
            layout="total, sizes, prev, pager, next, jumper" >
        </el-pagination>
    </div>
</template>

<script> 
import {getClassicList,saveFrontLog} from '../../../io/api.js'
import fjDetails from './fj_details.vue'
export default {
    props: ['keyword'], 
    components: {
        fjDetails,
    },
    data () {
        return {
            tableLoad:false,  
            tableList:[ ],
            isDetails:false,  
            rowInfo:{}, 
            pageInfo: {
                pageNum: 1,
                pageTotal: 1,
                total: 1,
                pageSize: 10,
            },
        }
    },
    methods: {
       getList(num,size){
            this.pageInfo.pageNum=1; 
            this.isSutra=true
            this.include_list() 
        },
        include_list(){
            this.tableLoad=true
            let params={
                filterNum: "0.8",
                flag:'use', 
                keyword:this.keyword,//方剂组成信息
                pageNumber:this.pageInfo.pageNum||1,
            }
            getClassicList(params).then(res=>{
                let data = res.data;
                if(data&&data.code==0){ 
                    this.tableList=data.data.list
                    this.pageInfo.total=data.data.total;
                }else{
                    this.$message.error( data.msg||'请求失败～')
                }
                this.tableLoad=false
            })
        },
        toDetails(row){ 
            const inputText = this.keyword || '';
            const typeName = '经典名方';
            const title = row.title || ''; 
            saveFrontLog({
                moduleName: "方剂识别",
                operationType: "查看详情",
                logContent: `输入【${inputText}】，查看【${typeName}】的【${title}】数据详情。`,
            }).then(res=>{
                // console.log(res)
            })
            this.isDetails=true;
            this.rowInfo=row;
            // this.$emit( 'toDetails',row)
        }, 

        //table隔行变色
        tableRowClassName({ row, rowIndex }) {
            row.rowIndex = rowIndex;
            if ((rowIndex-1) % 2 === 0) {
                return 'success-row' //这是类名
            } else  {
                return ''
            }
        },
        // table排序
        changePage(num) {
            this.pageInfo.pageNum = num; 
            this.include_list()
        },
        sizeChange(val) {
             this.pageInfo.pageSize=val;
             this.include_list()
        },
    }
}
</script>

<style lang="less" scoped>
.include{
    .tit{
        margin:50px 0  10px 0;
        font-weight: bold;
        font-size: 16px;
    } 
}
</style>